import { isInTMS2 } from 'ui/theme/theme'

export const getShipmentProfileLink = (shipmentId: string): string => {
	if (isInTMS2()) {
		return `/shipment_profile/${shipmentId}`
	} else {
		return `/shipments-v3/shipment-profile/${shipmentId}`
	}
}
